import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.gl',
    'package:data.universal.orgStructure.withoutDivisions',
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.amount',
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.gl',
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.personnel',
    'resource:data.dimensions.payrollExpenses.entities.entry',
    'resource:data.dimensions.payrollExpenses',
  ],
  description: 'TODO',
  name: 'Data - Payroll',
} as const satisfies core.quiver.Package
